import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetPipelineStatusV3Response } from './get-pipeline-status-v3-response';
import { getPipelineStatusV3ResponseSchema } from './get-pipeline-status-v3-response';

interface IGetPipelineStatusV3Params {
  collectionId?: number;
}

export async function getPipelineStatusV3Api(
  params?: IGetPipelineStatusV3Params,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetPipelineStatusV3Response>> {
  const query = params?.collectionId ? `?collectionId=${params.collectionId}` : '';
  return getRequest<IGetPipelineStatusV3Response>({
    path: `/sys/pipeline/v3${query}`,
    schema: getPipelineStatusV3ResponseSchema,
    options,
  });
}
